import jsPDF from "jspdf";
import arabicToThai from "../../../../../hook/arabicToThai";
import oneBell from "../../../../../assets/images/license/oneBell.png";
import oneJumbo from "../../../../../assets/images/license/3.png";
import signature_sakon from "../../../../../assets/images/license/24.png";
import dayjs from "dayjs";
import CurrencyFormat from "../../../../../hook/CurrencyFormat";
import "../../../../../assets/font/THSarabunNew-normal";
import "../../../../../assets/font/THSarabunNew-bold";

export async function createPdfRePrintAcc2And8(data = [],selectedContract, totalCount, startOffset = 0, lawyer = "sakon") {
  const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  console.log("data", data);

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "A4",
  });

  data?.forEach((person, index) => {
    if (index !== 0) pdf.addPage();

    let y = 15;
    // let y = 20;
    pdf.setFont("THSarabunNew", "normal");
    pdf.setFontSize(16);

    // ส่วนหัว
    pdf.text(`กรุณาส่ง`, 25, y);
    y += 5;
    // y += 10;

    pdf.text(
      `${person.customerFullname}  (${person.CONTNO}) (${
        person.customerTypeId === 0
          ? "ผู้เช่าซื้อ"
          : "คนค้ำ " + person.customerTypeId
      })`,
      40,
      y,
    );
    y += 5;

    // pdf.text(`${index + 1}/${currentBatchNumber}`, 180, y);
    pdf.text(`${startOffset + index + 1}/${totalCount}`, 180, y);

    pdf.text(person.ADDR1 ? person.ADDR1 : "-", 40, y);

    y += 5;
    pdf.text(
      `ต.${person.TUMB ? person.TUMB : "-"} อ.${
        person.AUMPDES ? person.AUMPDES : "-"
      } จ.${person.PROVDES ? person.PROVDES : "-"}`,
      40,
      y,
    );
    y += 5;
    pdf.text(person.ZIP, 40, y);

    y += 5;
    pdf.text(person.TELP, 40, y);

    y += 5;
    pdf.text(`(${dayjs(person.datetime).format("DD/MM/YYYY")})`, 40, y);

    // y += 38;
    y += 53;
    pdf.setFontSize(14);
    pdf.text(
      `วันที่ ${dayjs(person.datetime).add(543, "year").format("D MMMM YYYY")}`,
      150,
      y,
    );
    pdf.text(`เรื่อง   บอกกล่าวให้ชำระหนี้/บอกเลิกสัญญาเช่าซื้อ`, 20, y);
    y += 5;
    pdf.text(
      `เรียน   ${person?.BSNAM}${person?.BNAME1} ${
        person?.BNAME2 ? person?.BNAME2 : ""
      } (ผู้เช่าซื้อ)`,
      20,
      y,
    );

    let xLeft = 30;
    let xRight = 120;
    let yGUARANTORS = y + 5;

    person?.guarantor?.forEach((g, i) => {
      let x = i % 2 === 0 ? xLeft : xRight;

      pdf.text(
        `${g.snam} ${g.name1} ${g.name2} (${
          g.garno === 0 ? "ผู้เช่าซื้อ" : "คนค้ำ " + g.garno
        })`,
        x,
        yGUARANTORS,
      );

      // เมื่อครบคู่ (คนที่ 2 ในแถว) ให้ขึ้นบรรทัดใหม่
      if (i % 2 === 1) {
        yGUARANTORS += 5;
      }
    });

    // หลังจากเขียนผู้ค้ำประกันทั้งหมด อัปเดต y ให้ตรงกับตำแหน่งปัจจุบัน
    y = yGUARANTORS + 15;

    pdf.text(
      `อ้างถึง  สัญญาเช่าซื้อเลขที่ ${person?.CONTNO} ฉบับลงวันที่ ${dayjs(person?.SDATE).add(543, "year").format("D MMMM YYYY")}`,
      20,
      y,
    );
    //   เนื้อหา
    const indent = "          "; // เว้นบรรทัดเริ่มต้นแบบย่อหน้า (ประมาณ 8 ช่องว่าง)
    y += 5;
    const content = [
      `${indent}ตามที่ท่านทั้ง ${toThaiWord(
        person?.guarantor?.length + 1,
      )} คน ได้ทำหนังสือเช่าซื้อและสัญญาค้ำประกันซื้อรถยนต์ ${
        person?.BAAB ? person?.BAAB : "-"
      } ยี่ห้อ ${person?.TYPE ? person?.TYPE : "-"} หมายเลขเครื่องยนต์ ${
        person?.ENGNO ? person?.ENGNO : "-"
      } หมายเลขตัวถังรถยนต์ ${
        person?.STRNO ? person?.STRNO : "-"
      } หมายเลขทะเบียน ${
        person?.REGNO ? person?.REGNO : "-"
      } ไปจากบริษัทฯรายละเอียด ปรากฎตามสัญญาเช่าซื้อ ฉบับที่อ้างอิงถึง ไปจากบริษัทฯในราคา ${currencyFormatPoint(
        person?.TOTPRC,
      )} บาท ตกลงผ่อนชำระ ค่าเช่าซื้อให้แก่บริษัทฯ จำนวน ${
        person?.T_NOPAY
      } งวด งวดละ 1 เดือน ชำระเดือนละ ${currencyFormatPoint(
        person?.TOT_UPAY,
      )} บาท ของเดือนเริ่มชำระงวดแรกภายในวันที่ ${dayjs(person?.FDATE)
        .add(543, "year")
        .format("D MMMM YYYY")} และงวดสุดท้าย ชำระในวันที่ ${dayjs(
        person?.LDATE,
      )
        .add(543, "year")
        .format(
          "D MMMM YYYY",
        )} โดยผู้ค้ำประกันยินยอมรับผิดหากผู้เช่าซื้อไม่ชำระหนี้ดังกล่าว`,

      `${indent}บัดนี้ปรากฏว่าผู้เช่าซื้อประพฤติผิดสัญญา ไม่ชำระค่าเช่าซื้อให้แก่บริษัทฯ เป็นจำนวน ${
        person?.EXP_TO - person?.EXP_FRM
      } งวด ติดต่อกันตั้งแต่งวดที่  ${person?.EXP_FRM} เป็นต้นมา เป็นค่าเช่าซื้อที่ค้างชำระถึงวันที่ออกหนังสือฉับบนี้จำนวน ${currencyFormatPoint(
        person.EXP_AMT,
      )} บาท และคงเหลือค่าเช่าซื้อที่ค้างชำระจำนวน เงินทั้งสิ้น  ${currencyFormatPoint(parseFloat(person?.TOTPRC || 0) - parseFloat(person?.SMPAY || 0) + parseFloat(person.EXP_AMT || 0))} บาท`,

      `${indent}ดังนั้นข้าพเจ้าในฐานะผู้รับมอบอำนาจจากบริษัทฯ จึงขอให้ท่านทั้ง ${toThaiWord(
        person?.guarantor?.length + 1,
      )} คน นำจำนวนเงินค่าเช่าซื้อที่ค้างชำระดังกล่าว ข้างต้นพร้อมภาษีค่าเพิ่ม เบี้ยปรับค่าใช้จ่าย และเงินอื่นใดที่ต้องชำระให้ครบทันงวด ไปชำระที่บริษัทฯ ภายในกำหนด 30 วัน นับตั้งแต่วันที่ท่านได้รับหนังสือทวงถามฉบับนี้หากท่านทั้ง ${toThaiWord(
        person?.guarantor?.length + 1,
      )} คน เพิกเฉยไม่ดำเนินการภายในเวลาดังกล่าวข้างต้นแล้ว บริษัทฯ ขอให้ถือว่าหนังสือฉบับนี้เป็นการบอกเลิกสัญญาเช่าซื้อ ฉบับดังกล่าว และให้ท่าน ทั้ง ${toThaiWord(
        person?.guarantor?.length + 1,
      )} คน ร่วมกันหรือแทนกันส่งมอบรถยนต์ ที่เช่าซื้อคืนบริษัทฯในสภาพสมบูรณ์เรียบร้อยใช้การได้ดีหากท่านไม่สามารถมอบรถยนต์ คืนบริษัทฯ ให้ใช้ราคารถยนต์แทนจำนวน ${currencyFormatPoint(
        parseFloat(person?.TOTPRC || 0) -
          parseFloat(person?.SMPAY || 0) +
          parseFloat(person.EXP_AMT || 0),
      )} บาท (${numberToThaiText(parseFloat(person?.TOTPRC || 0) - parseFloat(person?.SMPAY || 0) + parseFloat(person.EXP_AMT || 0))}) ${person?.PAYAMTAROTHR ? "ค่าติดตามทวงถามเป็นเงิน " + currencyFormatPoint(person?.PAYAMTAROTHR) + " บาท" : ""}`,

      `${indent}นับแต่วันที่ผิดนัดพร้อมดอกเบี้ยในอัตราร้อยละ 15 ต่อปีไปชำระให้แก่บริษัทฯ ณ ที่ทำการบริษัทฯตามที่อยู่ข้างบนหนัง
สือฉบับนี้ในเวลาทำการปกติ หากท่านเพิกเฉยโดยมิดำเนินการดังกล่าวภายในเวลาที่กำหนดข้าพเจ้ามีความจำเป็นที่จะต้องดำเนิน
การกับท่านตาม กฎหมายต่อไป`,
    ];

    content.forEach((line) => {
      const splitText = pdf.splitTextToSize(line, 170);
      pdf.text(splitText, 20, y);
      y += splitText.length * 6;
    });

    pdf.text(`ขอแสดงความนับถือ`, 47, y + 2); // (x, y)
    let imageWidthImg = 25; // Adjust width to fit your needs
    let imageHeightImg = 15; // Adjust height to fit your needs
    if (lawyer === "pongsara") {
      pdf.addImage(oneJumbo, "PNG", 50, y + 3, imageWidthImg - 3, imageHeightImg - 3);
      pdf.text("(ร้อยตำรวจโทพงษ์ศรา วงษ์วีระขันธ์)", 40, y + 20); // (x, y)
    } else {
      pdf.addImage(signature_sakon, "PNG", 50, y + 3, imageWidthImg - 3, imageHeightImg - 3);
      pdf.text("(นายสกล พัดริม)", 50, y + 20); // (x, y)
    }
    pdf.text("ทนายความประจำบริษัทฯ", 45, y + 24); // (x, y)
    pdf.text("ผู้รับมอบอำนาจ", 50, y + 29); // (x, y)
    pdf.text(`ขอแสดงความนับถือ`, 145, y + 2); // (x, y)
    pdf.addImage(oneBell, "PNG", 145, y + 3, imageWidthImg, imageHeightImg);

    pdf.text(`( จิราภรณ์  พวงทอง)`, 145, y + 20); // (x, y)
    pdf.text("เลขานุการแผนกเร่งรัด", 145, y + 24); // (x, y)
    pdf.text("ผู้ออกจดหมาย", 150, y + 29); // (x, y)
    pdf.setFont("THSarabunNew", "bold");
    pdf.text(
      `หมายเหตุ : ยอดที่แจ้งเป็นยอด ณ วันที่ ${dayjs(person.DOCDT)
        .add(543, "year")
        .format(
          "D MMMM YYYY",
        )} หากมาชำระหลังจากนี้ยอดเงินอาจมีการเปลี่ยนแปลง ยอดที่แจ้งยังไม่รวมค่าใช้`,
      15,
      y + 40,
    );
    pdf.text(`จ่ายติดตามทวงถาม และเบี้ยปรับ`, 31, y + 45); // (x, y)
  });

  // // เพิ่มหน้าใหม่
  // pdf.addPage();

  // // ตั้งค่าฟอนต์
  // pdf.setFont("THSarabunNew", "normal");
  // pdf.setFontSize(16);

  // // config layout
  // let finalYLeft = 20;
  // let finalYRight = 20;
  // let leftX = 10;
  // let rightX = 115; // จุดเริ่มคอลัมน์ขวา
  // let rowHeight = 30; // ความสูงต่อคน
  // let count = 0;
  // let columnCount = 0;

  // data.forEach((person, index) => {
  //   const x = count % 2 === 0 ? leftX : rightX;
  //   let y = count % 2 === 0 ? finalYLeft : finalYRight;

  //   // --- ชื่อ + ประเภท ---
  //   const nameType = `${person.NAME} (${person.customerTypeId === 0 ? "ผู้เช่าซื้อ" : "คนค้ำ " + person.customerTypeId
  //     }) (${person.CONTNO})`;
  //   pdf.text(nameType, x, y);
  //   y += 6;

  //   // --- ที่อยู่ บรรทัด 1 ---
  //   if (person.address?.ADDR) {
  //     pdf.text(`เลขที่ ${person.address.ADDR}`, x, y);
  //     y += 6;
  //   }

  //   // --- ที่อยู่ บรรทัด 2 ---
  //   const addrLine2 = `ต.${person.address.TUMB} อ.${person.address.AUMPDES} จ.${person.address.PROVDES}`;
  //   pdf.text(addrLine2, x, y);
  //   y += 6;

  //   // --- ZIP ---
  //   pdf.text(person.address.ZIP || "", x, y);

  //   // --- อัปเดต Y ตามคอลัมน์ ---
  //   if (count % 2 === 0) {
  //     finalYLeft += rowHeight;
  //   } else {
  //     finalYRight += rowHeight;
  //     columnCount++;
  //   }

  //   count++;

  //   // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
  //   if (columnCount > 8) {
  //     columnCount = 0;
  //     console.log(" columnCount 0", columnCount);
  //     pdf.addPage();
  //     pdf.setFont("THSarabunNew", "normal");
  //     pdf.setFontSize(16);
  //     finalYLeft = 20;
  //     finalYRight = 20;
  //   }
  // });

  const pdfBlob = pdf.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  // window.open(pdfUrl);
  return pdfUrl;
}
